/*
  Sternify's own storefront script (app.sternify.com/storefront/st-product-information.js)
  emits a theme cart event after its own add-to-cart, then ~900ms later checks
  whether the drawer's innerHTML length changed to decide if the theme handled
  it. If not, it rebuilds the header section's markup from scratch as a
  fallback. Its "is the drawer already open" check grabs the FIRST <dialog> in
  the header section - on this theme that's the account-login drawer, not the
  cart drawer, so it always reads closed and takes the destructive rebuild
  path, wiping out the drawer we just opened. That's app-owned code we can't
  edit, so this watches for it happening and reopens the drawer - but only
  within a few seconds of a real cart update, and never if the shopper had
  just closed it themselves (tracked via dialog:close, which doesn't bubble
  so it's caught in the capture phase instead).
*/
(function () {
  var cartUpdatedAt = 0;
  var userClosedAt = 0;

  document.addEventListener('cart:update', function () {
    cartUpdatedAt = Date.now();
  });

  document.addEventListener(
    'dialog:close',
    function (e) {
      if (e.target && e.target.closest && e.target.closest('cart-drawer-component')) {
        userClosedAt = Date.now();
      }
    },
    true
  );

  function maybeReopen() {
    if (!cartUpdatedAt || Date.now() - cartUpdatedAt > 3000) return;
    if (userClosedAt > cartUpdatedAt) return;

    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer || typeof drawer.open !== 'function') return;

    var dialog = drawer.querySelector('dialog');
    if (dialog && !dialog.hasAttribute('open')) {
      drawer.open();
    }
  }

  function init() {
    var drawer = document.querySelector('cart-drawer-component');
    var section = drawer && drawer.closest('[id^="shopify-section-"]');
    if (!section) return;

    new MutationObserver(maybeReopen).observe(section, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
